import React, { useEffect, useState } from "react";
import "./SearchOption.css";

const SearchOption = () => {
  const [isScroll, setIsScroll] = useState(false);

  useEffect(() => {
    const changeBackground = () => {
      if (window.scrollY >= 10) {
        setIsScroll(true);
      } else {
        setIsScroll(false);
      }
    };
    window.addEventListener("scroll", changeBackground);
    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  }, [isScroll]);
  return (
    <div className="d-flex align-items-center justify-space-around">
      <div
        className={
          !isScroll
            ? "icon_text text-center px-0"
            : "active_icon_text text-center px-0"
        }
      >
        <div
          className={
            !isScroll ? "margin selector" : "active_selector margin ms-1"
          }
        >
          <select className="fa">
            <option value="fa fa-angle-down" className="px-2">
              What &#xf107;
            </option>
            {/* <option
              style={{ background: "#fff", padding: "20px" }}
              id="red"
              value=""
            >
              What
            </option> */}
          </select>
        </div>
        <div className="margin borderRight"></div>
        <div
          className={!isScroll ? "margin selector" : "active_selector margin"}
        >
          <select className="fa">
            <option value="fa fa-angle-down" className="px-2">
              Where &#xf107;
            </option>
            {/* <option value="">Where</option> */}
          </select>
        </div>
        <div className="margin borderRight"></div>

        <div
          className={!isScroll ? "margin selector" : "active_selector margin"}
        >
          <select className="fa">
            <option value="fa fa-angle-down" className="px-2">
              When &#xf107;
            </option>
            {/* <option value="fa fa-angle-down">When&#xf107;</option> */}

            {/* <option value="">When</option> */}
          </select>
        </div>
        <div
          className={
            !isScroll
              ? "rightBorder search_icon"
              : "active_search_icon rightBorder"
          }
        >
          <i className="fas fa-search"></i>
        </div>
      </div>
      <div className={!isScroll ? "list_items_btn" : "list_items_btn_active "}>
        <button>List An Item</button>
      </div>
    </div>
  );
};

export default SearchOption;
